module.exports = __webpack_public_path__ + "static/transport-management-system@2x-e8a4f8a6f644ab6f534defc83facf7af.jpg";